import {
  OdoslanaPripomienkaExistsApi,
  OdoslanaPripomienkaStatusEnum,
} from 'pripomienky-web-ts-axios';
import { AxiosRequestConfig } from 'axios';
import apiConfiguration from './configuration/apiConfiguration';
import { ClientResponse } from '../model/ClientResponse';
import { pripomienkyPrefixPath } from './configuration/apiConfigurationConstants';
import ClassType, { classTypeToGenerated } from '../model/pripomienka/ClassType';
import PripomienkyListFilter from '../model/filter/PripomienkyListFilter';
import { mapPripomienkaFilter } from './pripomienkaFilterClient';

const client = new OdoslanaPripomienkaExistsApi(apiConfiguration(pripomienkyPrefixPath));

// eslint-disable-next-line import/prefer-default-export
export const odoslanaPripomienkaExists = async (
  classType: ClassType,
  type: string,
  year: number,
  index: number,
  pripomienkaFilter: PripomienkyListFilter,
  options?: AxiosRequestConfig,
): Promise<ClientResponse<OdoslanaPripomienkaStatusEnum>> => {
  const {
    data,
    status,
  } = await client.odoslanaPripomienkaExists(
    type,
    year,
    index,
    classTypeToGenerated(classType),
    mapPripomienkaFilter(pripomienkaFilter),
    options,
  );
  return {
    data,
    responseCode: status,
  };
};
